module.exports = __webpack_public_path__ + "img/hychsm.bae7900b.png";